
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'billing-portal-ui',
  currentProjectVersion: 'static-1.1781',
  depVersions: {
  "billing-portal-ui": "static-1.1781",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.487",
  "foundations-components-test-utils": "static-1.5697",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8162",
  "hub-http-shared-msw-handlers": "static-1.10310",
  "hubspot-dlb": "static-2.1854",
  "react-dlb": "static-1.81",
  "reselect": "static-3.7",
  "billing-portal-service-types": "static-1.1619",
  "commerce-products-lib": "static-1.10082",
  "commerce-shared-components-lib": "static-1.18891",
  "customer-data-objects": "static-1.7819",
  "customer-data-properties": "static-1.52035",
  "customer-data-property-utils": "static-1.8235",
  "data-fetching-client": "static-1.9800",
  "foundations-assets": "static-1.5014",
  "foundations-components": "static-1.8214",
  "foundations-theming": "static-1.4575",
  "framework-data-table": "static-2.12234",
  "hub-http": "static-1.6362",
  "HubStyleTokens": "static-2.11611",
  "I18n": "static-7.1643",
  "meetings-icalendar-utils-lib": "static-1.774",
  "metrics-js": "static-1.9637",
  "object-builder-ui-client": "static-1.49230",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1199",
  "property-translator": "static-1.5537",
  "purchase-motions-components": "static-1.6129",
  "quartz-config": "static-1.995",
  "quartz-core": "static-1.6436",
  "quartz-routing": "static-1.647",
  "quick-fetch": "static-1.4024",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16829",
  "redux": "static-4.16",
  "redux-toolkit": "static-1.7",
  "rpc-client-utils": "static-1.4797",
  "sanitize-text": "static-1.8287",
  "smart-property-lib": "static-1.7989",
  "styled-components": "static-2.89",
  "ui-addon-form-validation": "static-1.11132",
  "ui-addon-i18n": "static-1.11289",
  "ui-addon-iframeable": "static-1.9210",
  "ui-addon-react-router-dom": "static-1.9676",
  "ui-addon-upgrades": "static-9.18186",
  "UIComponents": "static-3.8557",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "bend-plugin-trellis-migration": "static-1.3507",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3494",
  "quartz-webpack": "static-1.3441",
  "bend-plugin-quartz-routing": "static-1.295",
  "foundations-components-legacy": "static-1.1239",
  "HeadJS": "static-2.775",
  "quartz": "static-1.7217",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3273",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "ts-schema": "static-1.4188",
  "webpack-env": "static-1.54",
  "commerce-permissions": "static-1.915",
  "customer-data-tracking": "static-1.7027",
  "framework-data-schema-resolvers": "static-1.7034",
  "growth-payments-core": "static-1.25787",
  "hubspot-apollo-client": "static-1.5018",
  "immer": "static-1.33",
  "products-iframe-lib": "static-1.8315",
  "products-ui-components-shared-msw-handlers": "static-1.10692",
  "transmute": "static-2.85",
  "batch-promise": "static-1.1685",
  "crm_data": "static-4.92401",
  "cssUtils": "static-1.835",
  "customer-data-associations": "static-1.7473",
  "customer-data-objects-ui-components": "static-1.13170",
  "frontend-preferences-client": "static-1.8067",
  "graphql": "static-1.84",
  "hs-lodash": "static-4.45",
  "hs-story-utils": "static-1.9564",
  "HubStyle": "static-2.11918",
  "icons": "static-2.658",
  "payments-enrollment-embed-lib": "static-1.23353",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5447",
  "stripe-embedded-components": "static-1.7763",
  "StyleGuideUI": "static-3.490",
  "ui-addon-opt": "static-4.8502",
  "ui-images": "static-2.1193",
  "usage-tracker-container": "static-1-fix-bug-2917.4",
  "usage-tracker-core": "static-1-fix-bug-2917.4",
  "inbound-db-properties-service-client": "static-1.3953",
  "ai-components-ui-library": "static-1.9300",
  "atom": "static-1.5216",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2639",
  "calling-global-api": "static-1.64972",
  "calling-internal-common": "static-1.31453",
  "calling-lifecycle-internal": "static-1.66354",
  "calling-lifecycle-messages": "static-1.58648",
  "conditional-properties-service-client": "static-1.3904",
  "crm-links": "static-1.6449",
  "crm-message-bus": "static-1.43358",
  "crm-pipelines-api-client-types": "static-1.4244",
  "customer-data-properties-shared-msw-handlers": "static-1.9637",
  "external-options-client-types": "static-1.4233",
  "file-manager-components": "static-1.24039",
  "formula-editor": "static-1.14515",
  "google-libphonenumber": "static-1.40",
  "hs-promise-utils": "static-1.5734",
  "hs-resources": "static-1.319",
  "inbound-db-meta-service-client": "static-1.3694",
  "inbounddb-objects-service-types": "static-1.4324",
  "multi-currency-client-types": "static-1.3798",
  "PatternValidationJS": "static-1.437",
  "pipeline-validation-client-types": "static-1.4073",
  "property-value-citations": "static-1.2649",
  "pulse": "static-1.747",
  "quartz-i18n": "static-1.892",
  "reference-resolvers-lite": "static-1.8237",
  "SharedI18nStrings": "static-1.182",
  "tiered-pricing": "static-1.1598",
  "topics-actions-lib": "static-1.238",
  "usage-tracker": "static-1-fix-bug-2917.4",
  "user-context": "static-1.5249",
  "zustand": "static-1.74",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4483",
  "floating-ui": "static-1.59",
  "foundations-theming-specialty": "static-1.2291",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.41",
  "react-virtualized": "static-2.101",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2227",
  "ui-fonts": "static-1.873",
  "bend-plugin-foundations-theming": "static-1.3058",
  "foundations-theming-base": "static-1.3560",
  "stylex": "static-1.36",
  "customer-data-reference-ui-components": "static-1.13316",
  "customer-data-ui-utilities": "static-1.9965",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8316",
  "reporting-data": "static-1.68120",
  "sanitize": "static-1.4617",
  "tanstack-virtual": "static-1.32",
  "ui-addon-draggable": "static-3.4901",
  "hs-locale-management": "static-1.188",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "interframe": "static-3.4899",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1-fix-bug-2917.4",
  "merchandise-lib": "static-1.266",
  "onboarding-scopes": "static-1.6601",
  "purchase-motions-api": "static-1.6132",
  "signup-constants": "static-1.19215",
  "signup-ui-url-generator": "static-2.8200",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4757",
  "jasmine": "static-4.4465",
  "jasmine-runner": "static-1.6597",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.892",
  "quartz-head": "static-1.882",
  "quartz-test": "static-1.892",
  "quartz-tracking": "static-1.596",
  "trellis-components": "static-1.2246",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "bend-plugin-chirp-manifest": "static-1.207",
  "chirp-fetch": "static-1.2028",
  "data-agent-kit": "static-1.430",
  "data-token-picker": "static-1.16658",
  "feedback-loader": "static-1.29561",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10393",
  "fsm": "static-1.3871",
  "policy-lib": "static-1.6926",
  "react-colorpicker": "static-2.10348",
  "react-tinymce": "static-1.55614",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10456",
  "rich-text-lib": "static-1.20078",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54740",
  "tinymce-plugins": "static-1.57854",
  "tinymce-themes": "static-1.56710",
  "magpie-lib": "static-1.5644",
  "navigation-messaging": "static-1.7678",
  "laboratory-lib": "static-3.7293",
  "salesImages": "static-1.528",
  "bender-build-tools": "static-1.3301",
  "usage-tracker-anonymous": "static-1-fix-bug-2917.4",
  "usage-tracker-public": "static-1-fix-bug-2917.4",
  "fdsr-migration-layer": "static-1.153",
  "framework-builder-read-service-client": "static-1.4112",
  "framework-data-schema-quick-fetch": "static-1.6939",
  "persist-promise": "static-1.3842",
  "seat-types-lib": "static-1.311",
  "apollo-link-hub-http": "static-2.4792",
  "hubspot-apollo-cache": "static-1.477",
  "sales-views-client-types": "static-1.4398",
  "crm_universal": "static-1.22262",
  "customer-data-email": "static-1.18293",
  "native-integrations-shared-strings": "static-1.7921",
  "superstore": "static-1.4900",
  "sassPrefix": "static-1.158",
  "copilot-toolkit": "static-1.11494",
  "growth-onboarding-confetti": "static-1.3206",
  "growth-onboarding-feedback-components": "static-1.6719",
  "growth-onboarding-reliability": "static-1.5222",
  "marketplace-ui-apps-core": "static-1.18762",
  "onboarding-tours": "static-1.16875",
  "stripe-connect-js": "static-1.71",
  "chatspot-core": "static-1.21986",
  "ContentUtils": "static-1.68773",
  "calling-error-reporting": "static-1.31460",
  "shared-worker-versioning": "static-1.11176",
  "calling-usage-tracker": "static-1.6683",
  "voice-sms-access-library": "static-1.1509",
  "conversations-skeleton-state": "static-1.7388",
  "react-immutable-render-mixin": "static-1.9",
  "location-customization-utils-lib": "static-1.9657",
  "restore-request-side-panel-lib": "static-1.1253",
  "breeze-engine-lib": "static-1.1200",
  "immerable": "static-1.4291",
  "video-components-external": "static-1.11748",
  "video-data-lib": "static-1.35406",
  "bark-lib": "static-1.16606",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.97",
  "crm-properties-common-lib": "static-1.6031",
  "react-codemirror": "static-1.10768",
  "event-emitter": "static-1.1090",
  "bend-plugin-pulse": "static-1.250",
  "fast-json-patch": "static-1.65",
  "getting-started-shared-tasks": "static-1.18802",
  "getting-started-shared-tasks-store": "static-1.17920",
  "onboarding-tours-utils": "static-1.941",
  "react-dnd-compat": "static-1.4755",
  "reporting-client-types": "static-1.2587",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.73",
  "hubspotter-http-shared-msw-handlers": "static-1.10308",
  "usage-tracker-session-replay": "static-1-fix-bug-2917.4",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1084",
  "highcharts": "static-8.106",
  "trellis-story-utils": "static-1.4650",
  "storybook-react": "static-1.35",
  "FileManagerLib": "static-1.39679",
  "hub-http-contrib": "static-1.3184",
  "tinymce-data": "static-1.40825",
  "ui-addon-sales-email": "static-1.5351",
  "content-assistance-lib": "static-1.7980",
  "FileManagerCore": "static-1.39538",
  "layout-dnd-components": "static-1.12723",
  "layout-dnd-utils": "static-1.11698",
  "ui-addon-emoji-picker": "static-1.10025",
  "ui-brand-identity-lib": "static-1.15798",
  "NamespacedHubStyle": "static-2.9160",
  "idb-keyval": "static-1.46",
  "magpie-types": "static-1.5104",
  "reactive-lib": "static-1.866",
  "simple-logging-lib": "static-1.3189",
  "amplitude-session-replay-browser": "static-1.60",
  "FormUrlGenerator": "static-2.4863",
  "sequences-lib": "static-1.8285",
  "timezone-utils": "static-2.5384",
  "ui-gdpr-components": "static-1.10493",
  "developer-experience-shared-components": "static-1.10672",
  "immutable-less": "static-1.4792",
  "marketplace-ui-client-types": "static-1.17637",
  "marketplace-ui-common": "static-1.20230",
  "ui-addon-integrations-directory-panel": "static-2.8152",
  "ui-extensibility-client-types": "static-1.4065",
  "ui-universal-auth": "static-1.9147",
  "growth-data-modal": "static-1.5664",
  "growth-onboarding-next-action-utils": "static-1.2317",
  "navigation-components": "static-1.18351",
  "onboarding-tours-client": "static-1.5089",
  "ui-shepherd-react": "static-3.10398",
  "ui-shepherd-tracker": "static-1.7779",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4955",
  "content-icons-ui": "static-1.2270",
  "integrations-lib": "static-1.16595",
  "underscore": "static-1.8",
  "calling-orchestration-schema": "static-1.36286",
  "crm-record-cards-service-types": "static-1.3692",
  "breeze-engine-core": "static-1.478",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "content-media-composition-data-lib": "static-1.12753",
  "content-media-compositions": "static-2.16760",
  "media-bridge-lib": "static-1.19175",
  "react-reducer-toolkit": "static-1.15979",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "audio-components": "static-1.6136",
  "FileManagerImages": "static-1.37190",
  "video-components": "static-1.13750",
  "ui-addon-video-player": "static-1.8846",
  "ui-coaching-tips": "static-1.28947",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4675",
  "video-embed": "static-1.36240",
  "ContentData": "static-1.68848",
  "layout-data-lib": "static-1.10023",
  "emoji-mart": "static-3.4",
  "prosemirror": "static-1.13",
  "sequences-client-types-lib": "static-1.8142",
  "apps-service-types": "static-1.3941",
  "oauth-service-types": "static-1.4395",
  "ai-settings-ui-library": "static-1.8114",
  "nav-meta": "static-1.29988",
  "react-window": "static-1.13",
  "unified-auth-core-lib": "static-1.943",
  "onboarding-data-sync-lib": "static-1.2213",
  "growth-onboarding-next-action-components": "static-1.2345",
  "user-context-client": "static-1.4718",
  "nest": "static-1.374",
  "flux-actions": "static-1.350",
  "integrations-error-boundary-lib": "static-1.14010",
  "integrations-tracking-lib": "static-1.5748",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10503",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.661",
  "social-insights-client-types": "static-1.22420",
  "outpost": "static-1.4309",
  "advanced-menus-core": "static-1.15368",
  "advanced-menus-lib": "static-1.12273",
  "ExportDialog": "static-6.10520",
  "ui-memberships-settings-lib": "static-1.34422",
  "final-form": "static-1.72",
  "simple-data-table": "static-1.3169",
  "InboxConnectUtils": "static-4.15191",
  "meetings-connect-utils-lib": "static-1.7746",
  "universal-page-editor-lib": "static-1.3152",
  "adobe-sign-auth-lib": "static-1.83",
  "ads-unified-auth-lib": "static-1.544",
  "google-sheets-integration-lib": "static-1.646",
  "microsoft-drive-integration-lib": "static-1.808",
  "surveymonkey-integration-lib": "static-1.102",
  "slack-ui-library": "static-1.10539",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15367",
  "simple-menus-lib": "static-1.16884"
},
  depPathPrefixes: {
  "billing-portal-ui": "/billing-portal-ui/static-1.1781",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.487",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5697",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8162",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10310",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "react-dlb": "/react-dlb/static-1.81",
  "reselect": "/reselect/static-3.7",
  "billing-portal-service-types": "/billing-portal-service-types/static-1.1619",
  "commerce-products-lib": "/commerce-products-lib/static-1.10082",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18891",
  "customer-data-objects": "/customer-data-objects/static-1.7819",
  "customer-data-properties": "/customer-data-properties/static-1.52035",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8235",
  "data-fetching-client": "/data-fetching-client/static-1.9800",
  "foundations-assets": "/foundations-assets/static-1.5014",
  "foundations-components": "/foundations-components/static-1.8214",
  "foundations-theming": "/foundations-theming/static-1.4575",
  "framework-data-table": "/framework-data-table/static-2.12234",
  "hub-http": "/hub-http/static-1.6362",
  "HubStyleTokens": "/HubStyleTokens/static-2.11611",
  "I18n": "/I18n/static-7.1643",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.774",
  "metrics-js": "/metrics-js/static-1.9637",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49230",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1199",
  "property-translator": "/property-translator/static-1.5537",
  "purchase-motions-components": "/purchase-motions-components/static-1.6129",
  "quartz-config": "/quartz-config/static-1.995",
  "quartz-core": "/quartz-core/static-1.6436",
  "quartz-routing": "/quartz-routing/static-1.647",
  "quick-fetch": "/quick-fetch/static-1.4024",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16829",
  "redux": "/redux/static-4.16",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rpc-client-utils": "/rpc-client-utils/static-1.4797",
  "sanitize-text": "/sanitize-text/static-1.8287",
  "smart-property-lib": "/smart-property-lib/static-1.7989",
  "styled-components": "/styled-components/static-2.89",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11132",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11289",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9210",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9676",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18186",
  "UIComponents": "/UIComponents/static-3.8557",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3507",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3494",
  "quartz-webpack": "/quartz-webpack/static-1.3441",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.295",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1239",
  "HeadJS": "/HeadJS/static-2.775",
  "quartz": "/quartz/static-1.7217",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3273",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "ts-schema": "/ts-schema/static-1.4188",
  "webpack-env": "/webpack-env/static-1.54",
  "commerce-permissions": "/commerce-permissions/static-1.915",
  "customer-data-tracking": "/customer-data-tracking/static-1.7027",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7034",
  "growth-payments-core": "/growth-payments-core/static-1.25787",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5018",
  "immer": "/immer/static-1.33",
  "products-iframe-lib": "/products-iframe-lib/static-1.8315",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10692",
  "transmute": "/transmute/static-2.85",
  "batch-promise": "/batch-promise/static-1.1685",
  "crm_data": "/crm_data/static-4.92401",
  "cssUtils": "/cssUtils/static-1.835",
  "customer-data-associations": "/customer-data-associations/static-1.7473",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13170",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8067",
  "graphql": "/graphql/static-1.84",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-story-utils": "/hs-story-utils/static-1.9564",
  "HubStyle": "/HubStyle/static-2.11918",
  "icons": "/icons/static-2.658",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23353",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5447",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7763",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "ui-addon-opt": "/ui-addon-opt/static-4.8502",
  "ui-images": "/ui-images/static-2.1193",
  "usage-tracker-container": "/usage-tracker-container/static-1-fix-bug-2917.4",
  "usage-tracker-core": "/usage-tracker-core/static-1-fix-bug-2917.4",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3953",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9300",
  "atom": "/atom/static-1.5216",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2639",
  "calling-global-api": "/calling-global-api/static-1.64972",
  "calling-internal-common": "/calling-internal-common/static-1.31453",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66354",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58648",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3904",
  "crm-links": "/crm-links/static-1.6449",
  "crm-message-bus": "/crm-message-bus/static-1.43358",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4244",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9637",
  "external-options-client-types": "/external-options-client-types/static-1.4233",
  "file-manager-components": "/file-manager-components/static-1.24039",
  "formula-editor": "/formula-editor/static-1.14515",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "hs-promise-utils": "/hs-promise-utils/static-1.5734",
  "hs-resources": "/hs-resources/static-1.319",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3694",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4324",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3798",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4073",
  "property-value-citations": "/property-value-citations/static-1.2649",
  "pulse": "/pulse/static-1.747",
  "quartz-i18n": "/quartz-i18n/static-1.892",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8237",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "tiered-pricing": "/tiered-pricing/static-1.1598",
  "topics-actions-lib": "/topics-actions-lib/static-1.238",
  "usage-tracker": "/usage-tracker/static-1-fix-bug-2917.4",
  "user-context": "/user-context/static-1.5249",
  "zustand": "/zustand/static-1.74",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4483",
  "floating-ui": "/floating-ui/static-1.59",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2291",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "react-virtualized": "/react-virtualized/static-2.101",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2227",
  "ui-fonts": "/ui-fonts/static-1.873",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3058",
  "foundations-theming-base": "/foundations-theming-base/static-1.3560",
  "stylex": "/stylex/static-1.36",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13316",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9965",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8316",
  "reporting-data": "/reporting-data/static-1.68120",
  "sanitize": "/sanitize/static-1.4617",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4901",
  "hs-locale-management": "/hs-locale-management/static-1.188",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "interframe": "/interframe/static-3.4899",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-fix-bug-2917.4",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "onboarding-scopes": "/onboarding-scopes/static-1.6601",
  "purchase-motions-api": "/purchase-motions-api/static-1.6132",
  "signup-constants": "/signup-constants/static-1.19215",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8200",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4757",
  "jasmine": "/jasmine/static-4.4465",
  "jasmine-runner": "/jasmine-runner/static-1.6597",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.892",
  "quartz-head": "/quartz-head/static-1.882",
  "quartz-test": "/quartz-test/static-1.892",
  "quartz-tracking": "/quartz-tracking/static-1.596",
  "trellis-components": "/trellis-components/static-1.2246",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.207",
  "chirp-fetch": "/chirp-fetch/static-1.2028",
  "data-agent-kit": "/data-agent-kit/static-1.430",
  "data-token-picker": "/data-token-picker/static-1.16658",
  "feedback-loader": "/feedback-loader/static-1.29561",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10393",
  "fsm": "/fsm/static-1.3871",
  "policy-lib": "/policy-lib/static-1.6926",
  "react-colorpicker": "/react-colorpicker/static-2.10348",
  "react-tinymce": "/react-tinymce/static-1.55614",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10456",
  "rich-text-lib": "/rich-text-lib/static-1.20078",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54740",
  "tinymce-plugins": "/tinymce-plugins/static-1.57854",
  "tinymce-themes": "/tinymce-themes/static-1.56710",
  "magpie-lib": "/magpie-lib/static-1.5644",
  "navigation-messaging": "/navigation-messaging/static-1.7678",
  "laboratory-lib": "/laboratory-lib/static-3.7293",
  "salesImages": "/salesImages/static-1.528",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-fix-bug-2917.4",
  "usage-tracker-public": "/usage-tracker-public/static-1-fix-bug-2917.4",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.153",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4112",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6939",
  "persist-promise": "/persist-promise/static-1.3842",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4792",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.477",
  "sales-views-client-types": "/sales-views-client-types/static-1.4398",
  "crm_universal": "/crm_universal/static-1.22262",
  "customer-data-email": "/customer-data-email/static-1.18293",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7921",
  "superstore": "/superstore/static-1.4900",
  "sassPrefix": "/sassPrefix/static-1.158",
  "copilot-toolkit": "/copilot-toolkit/static-1.11494",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3206",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6719",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5222",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18762",
  "onboarding-tours": "/onboarding-tours/static-1.16875",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "chatspot-core": "/chatspot-core/static-1.21986",
  "ContentUtils": "/ContentUtils/static-1.68773",
  "calling-error-reporting": "/calling-error-reporting/static-1.31460",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11176",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6683",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1509",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7388",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9657",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1253",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1200",
  "immerable": "/immerable/static-1.4291",
  "video-components-external": "/video-components-external/static-1.11748",
  "video-data-lib": "/video-data-lib/static-1.35406",
  "bark-lib": "/bark-lib/static-1.16606",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.97",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6031",
  "react-codemirror": "/react-codemirror/static-1.10768",
  "event-emitter": "/event-emitter/static-1.1090",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.250",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18802",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17920",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.941",
  "react-dnd-compat": "/react-dnd-compat/static-1.4755",
  "reporting-client-types": "/reporting-client-types/static-1.2587",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.73",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10308",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-fix-bug-2917.4",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1084",
  "highcharts": "/highcharts/static-8.106",
  "trellis-story-utils": "/trellis-story-utils/static-1.4650",
  "storybook-react": "/storybook-react/static-1.35",
  "FileManagerLib": "/FileManagerLib/static-1.39679",
  "hub-http-contrib": "/hub-http-contrib/static-1.3184",
  "tinymce-data": "/tinymce-data/static-1.40825",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5351",
  "content-assistance-lib": "/content-assistance-lib/static-1.7980",
  "FileManagerCore": "/FileManagerCore/static-1.39538",
  "layout-dnd-components": "/layout-dnd-components/static-1.12723",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11698",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10025",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15798",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9160",
  "idb-keyval": "/idb-keyval/static-1.46",
  "magpie-types": "/magpie-types/static-1.5104",
  "reactive-lib": "/reactive-lib/static-1.866",
  "simple-logging-lib": "/simple-logging-lib/static-1.3189",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4863",
  "sequences-lib": "/sequences-lib/static-1.8285",
  "timezone-utils": "/timezone-utils/static-2.5384",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10493",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10672",
  "immutable-less": "/immutable-less/static-1.4792",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17637",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20230",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8152",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4065",
  "ui-universal-auth": "/ui-universal-auth/static-1.9147",
  "growth-data-modal": "/growth-data-modal/static-1.5664",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2317",
  "navigation-components": "/navigation-components/static-1.18351",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5089",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10398",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7779",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4955",
  "content-icons-ui": "/content-icons-ui/static-1.2270",
  "integrations-lib": "/integrations-lib/static-1.16595",
  "underscore": "/underscore/static-1.8",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36286",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3692",
  "breeze-engine-core": "/breeze-engine-core/static-1.478",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12753",
  "content-media-compositions": "/content-media-compositions/static-2.16760",
  "media-bridge-lib": "/media-bridge-lib/static-1.19175",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.15979",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "audio-components": "/audio-components/static-1.6136",
  "FileManagerImages": "/FileManagerImages/static-1.37190",
  "video-components": "/video-components/static-1.13750",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8846",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28947",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4675",
  "video-embed": "/video-embed/static-1.36240",
  "ContentData": "/ContentData/static-1.68848",
  "layout-data-lib": "/layout-data-lib/static-1.10023",
  "emoji-mart": "/emoji-mart/static-3.4",
  "prosemirror": "/prosemirror/static-1.13",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8142",
  "apps-service-types": "/apps-service-types/static-1.3941",
  "oauth-service-types": "/oauth-service-types/static-1.4395",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8114",
  "nav-meta": "/nav-meta/static-1.29988",
  "react-window": "/react-window/static-1.13",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.943",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2213",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2345",
  "user-context-client": "/user-context-client/static-1.4718",
  "nest": "/nest/static-1.374",
  "flux-actions": "/flux-actions/static-1.350",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14010",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5748",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10503",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.661",
  "social-insights-client-types": "/social-insights-client-types/static-1.22420",
  "outpost": "/outpost/static-1.4309",
  "advanced-menus-core": "/advanced-menus-core/static-1.15368",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12273",
  "ExportDialog": "/ExportDialog/static-6.10520",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34422",
  "final-form": "/final-form/static-1.72",
  "simple-data-table": "/simple-data-table/static-1.3169",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15191",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7746",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3152",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.83",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.544",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.646",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.808",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.102",
  "slack-ui-library": "/slack-ui-library/static-1.10539",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15367",
  "simple-menus-lib": "/simple-menus-lib/static-1.16884"
}
};
